import { EnrichWithDatapoints, IGoalWithDatapoints } from 'motw_core/Repositories/DatapointRepository';
import GoalEditorPanel from '../GoalEditorPanel';
import ClientDataProvider from 'source/app/services/External/ClientDataProvider/ClientDataProvider';

export async function PrepareGEPState(GEP: GoalEditorPanel) {
	const incoming = GEP.props.goal;
	
	const merged = Object.assign(
		{},
		GEP.state.currentState,
		incoming
	) as IGoalWithDatapoints;

	await EnrichWithDatapoints(incoming, merged, ClientDataProvider);

	const GEPStateContainer: IGoalWithDatapoints = {
		...merged,
		id: incoming.id,
	};

	GEP.setState({
		currentState: GEPStateContainer,
		previousState: GEPStateContainer
	});
}
